// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"606":"7d37b467","889":"7dbfb702","987":"56a90b3e"}[chunkId] + ".js";
};